<template>
  <div class="FansRecommendedMaterial">

    <div class="title">{{ title }}</div>

    <PicList
      class="PicList"
      v-bind="$attrs"
      v-on="$listeners"
      params="params"
    />
  </div>
</template>

<script>
import PicList from '@/components/pic/pic-list/pic-list';

export default {
  name: "RecommendedMaterial",
  components:{
    PicList
  },
  props:{
    title: String,
    params: {
      type: String,
      default: '',
    },
  }
}
</script>

<style lang="scss" scoped>
.FansRecommendedMaterial{
  .title{
    height: 31px;
    font-size: 24px;
    font-weight: bold;
    color: #0A2540;
    line-height: 31px;
    letter-spacing: 1px;
    margin-bottom: 32px;
  }
}

.PicList {
  /deep/ .inner_center {
    width: 1200px !important;
  }

  /deep/ .PicItem {
    width: 279px !important;
    height: 365px !important;
    margin: 0 28px 28px 0;

    &:nth-child(4n) {
      margin-right: 0;
    }
  }
}
</style>
